<template lang="pug">
  div.body.body-table.operator-table
    div.table-choose-panel
      div.toolbar-table
        div.select Обслуживание объекта
        //toolbarBlockClear
        // должна остаться вот такая структура:
        div.toolbar.toolbar--modal
          div.line
            // добавлен модификатор .search--rounded
            div.actions-panel
              e-button-add(@click="addNewRowToTable()")
              // button(v-if="role!=='guest'" @click="addNewRowToTable()").actions-panel__button.btn-add.green

      div
          e-table-editable(
            ref="operator"
            :attributes="operatorAttr"
            :dataUrl="operatorDataUrl"
            :postUrl="operatorPostUrl"
            :patchUrl="operatorPatchUrl"
            :deleteUrl="operatorDeleteUrl"
            :enableOnAdd="enableOnAdd"
            :afterFetchData="afterFetchData"
             :afterValidate="afterValidate"
            :tableInOnlineMode="tableInOnlineMode"
          )
</template>

<script>
  import {garbage, core, tko} from '@/api/api-endpoints'
  import {garbageOffline}     from '@/api/api-offline-endpoints'
  import operatorTableMixin   from './mixins/operator-table-mixin.js'

  export default {
    name: 'operator-table',
    mixins: [operatorTableMixin],
    props: {
      tabView: null,
      id: null
    },
    computed: {
      operatorDataUrl () {
        if (this.id) {
          let routeQuery = {query: {}}

          return garbage.services(routeQuery, this.id)
        }

        // if new record, offline save
        return garbageOffline.operatorTable(this.$route.name)
      }
    },
    methods: {
      suggestionEndpointObject (ctx, q) {
        return tko.objects({query: {q: q, 'per-page': 50}})
      },
      suggestionEndpointOperatorTransport (ctx, q) {
        return core.statuses({fields: 'tko_operator_transport'})
      },
      suggestionEndpointOperatorService (ctx, q) {
        return core.statuses({fields: 'tko_operator'})
      },
      suggestionEndpointGarbageGroup (ctx, q) {
        return core.statuses({fields: 'garbage_group'})
      },
      operatorPostUrl (context, model) {
        return garbage.servicePost(this.id)
      },
      operatorPatchUrl (context, model) {
        return garbage.servicePatch(model.id)
      },
      operatorDeleteUrl (context, model) {
        return garbage.serviceDelete(model.id)
      }
    }
  }
</script>
